import React, {FC, useEffect, useState} from "react";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Nav from "components/Nav/Nav";
import NavItem from "components/NavItem/NavItem";
import Avatar from "components/Avatar/Avatar";
import ArchiveFilterListBox from "components/ArchiveFilterListBox/ArchiveFilterListBox";
import {Helmet} from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import Card11 from "components/Card11/Card11";
import NcImage from "components/NcImage/NcImage";
import {useParams} from "react-router-dom";
import {auth, db} from "../../configs/firebase-config";
import {collection, doc, DocumentData, getDoc, getDocs, orderBy, query} from "firebase/firestore";
import {checkBookmark, checkPostLiked, displayToast, toastType} from "../../global/Functions";
import {FilterContext} from "global/FilterContext";


export interface PageAuthorProps {
  className?: string;
}

const FILTERS = [
  { name: "Most Recent" },
  { name: "Curated by Admin" },
  { name: "Most Appreciated" },
  { name: "Most Discussed" },
  { name: "Most Viewed" },
];
const TABS = ["Articles", "Favorites", "Saved"];

const filterKey: any = {
  "Most Recent": "createdAt",
  "Curated by Admin": "createdAt",
  "Most Appreciated": "heartCount",
  "Most Discussed": "commentCount",
  "Most Viewed": "priority"
}

const PageAuthor: FC<PageAuthorProps> = ({ className = "" }) => {
  const [tabActive, setTabActive] = useState<string>(TABS[0]);
  const [userData, setUserData] = useState<any>();
  const [filter, setFilter] = useState<string>("Most Recent");
  const [posts, setPosts] = useState<any>();
  const [previousTab, setPreviousTab] = useState<string>("Articles");
  let { uid } = useParams<{ uid: string }>();
  const userDocRef = doc(db, `users/${uid}`);
  const postCollectionRef = collection(db, `posts/${uid}/posts`);

  const handleClickTab = (item: string) => {
    if (item === tabActive) {
      return;
    }
    setTabActive(item);
  };

  const getUserData = async () => {
    const result = await getDoc(userDocRef);
    setUserData(result.data());
  }

  const sort_by = (field: any, reverse: any, primer: any) => {

    const key = primer ?
      function(x: any) {
        return primer(x[field])
      } :
      function(x: any) {
        return x[field]
      };

    reverse = !reverse ? 1 : -1;

    return function(a: any, b: any) {
      return a = key(a), b = key(b), reverse * (Number(a > b) - Number(b > a));
    }
  }

  const getPosts = async (query: any) => {
    const results = await getDocs(query);
    const source = results.metadata.fromCache ? "local cache" : "server";
    console.log("Post came from " + source);
    if (results.empty) return;
    return await Promise.all(results.docs.map(async (document: DocumentData): Promise<any> => {
      return {
        href: `/single/${document.get("userId")}/${document.id}`.split(" ").join('%'),
        id: document.id,
        postType: "standard",
        date: document.get("createdAt").toDate().toDateString(),
        featuredImage: document.get("image").downloadURL,
        like: {
          count: document.get("heartCount"),
          isLiked: await checkPostLiked(document.id)
        },
        bookmark: {count: 3502, isBookmarked: await checkBookmark(document.id)},
        ...document.data()
      };
    }));
  }

  useEffect(() => {
    getUserData();
  }, [])

  useEffect(() => {
    if (!filter) return;
    if(tabActive === "Articles") {
     getPosts(query(postCollectionRef, orderBy(filterKey[filter], "desc"))).then((result) => {
       setPosts(result);
     });
      setPreviousTab("Articles");
    }
    if(tabActive === "Favorites") {
      if (auth.currentUser) {
        if (previousTab !== "Articles") {
          console.log("IN FAVOURITES")
          getPosts(query(postCollectionRef, orderBy(filterKey[filter], "desc"))).then((result) => {
            if (!result) return;
            setPosts(
              result
                .filter((post: any) => {if(post.like.isLiked) return post})
                .sort(sort_by(filterKey[filter], true, parseInt))
            );
          });
        } else {
          setPosts(
            posts
              .filter((post: any) => {if(post.like.isLiked) return post})
              .sort(sort_by(filterKey[filter], true, parseInt))
          )
        }
        setPreviousTab("Favourites");
      } else {
        displayToast("Log in to view your favourites", toastType.info)
      }
    }
    if(tabActive === "Saved"){
      if (auth.currentUser) {
        if (previousTab !== "Articles") {
          console.log("IN SAVED")
          getPosts(query(postCollectionRef, orderBy(filterKey[filter], "desc"))).then((result) => {
            if (!result) return;
            setPosts(
              result
                .filter((post: any) => {if(post.bookmark.isBookmarked) return post})
                .sort(sort_by(filterKey[filter], true, parseInt))
            );
          });
        } else {
          setPosts(
            posts
              .filter((post: any) => {if(post.bookmark.isBookmarked) return post})
              .sort(sort_by(filterKey[filter], true, parseInt))
          )
        }
        setPreviousTab("Saved");
      } else {
        displayToast("Log in to view saved posts", toastType.info)
      }
    }
  }, [tabActive, filter])


  return (
    <div className={`PageAuthor  ${className}`} data-nc-id="PageAuthor">
      <Helmet>
        <title>Profile | CryptoVerse</title>
      </Helmet>
      {userData ?
        <>
          {/* HEADER */}
          <div className="w-screen px-2 xl:max-w-screen-2xl mx-auto">
            <div className="rounded-3xl md:rounded-[40px] relative aspect-w-16 aspect-h-12 sm:aspect-h-7 xl:sm:aspect-h-6 overflow-hidden ">
              <NcImage
                containerClassName="absolute inset-0"
                src="https://miro.medium.com/max/1400/1*hN4CaFvjeFy6KUmETX2kdw.jpeg"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="relative container -mt-20 lg:-mt-48">
              <div className=" bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 p-5 lg:p-16 rounded-[40px] shadow-2xl flex flex-col sm:flex-row sm:items-center">
                <Avatar
                  containerClassName="ring-4 ring-white dark:ring-0 shadow-2xl"
                  imgUrl={userData? userData.photoURL : ""}
                  sizeClass="w-20 h-20 text-xl lg:text-2xl lg:w-36 lg:h-36"
                  radius="rounded-full"
                />
                <div className="mt-5 sm:mt-0 sm:ml-8 space-y-4 max-w-lg">
                  <h2 className="inline-block text-2xl sm:text-3xl md:text-4xl font-semibold">
                    {`${userData.firstName} ${userData.lastName}`}
                  </h2>
                  <span className="block text-sm text-neutral-6000 dark:text-neutral-300 md:text-base">
                CryptoVerse Member
              </span>
                </div>
              </div>
            </div>
          </div>
          {/* ====================== END HEADER ====================== */}

          <div className="container py-16 lg:pb-28 lg:pt-20 space-y-16 lg:space-y-28">
            { posts ?
              <main>
                {/* TABS FILTER */}
                <div className="flex flex-col sm:items-center sm:justify-between sm:flex-row">
                  <Nav className="sm:space-x-2">
                    {TABS.map((item, index) => (
                      <NavItem
                        key={index}
                        isActive={tabActive === item}
                        onClick={() => handleClickTab(item)}
                      >
                        {item}
                      </NavItem>
                    ))}
                  </Nav>
                  <div className="block my-4 border-b w-full border-neutral-100 sm:hidden"></div>
                  <div className="flex justify-end">
                    <FilterContext.Provider value={{setFilter}}>
                      <ArchiveFilterListBox lists={FILTERS} />
                    </FilterContext.Provider>
                  </div>
                </div>

                {/* LOOP ITEMS */}

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8 mt-8 lg:mt-10">
                  {posts?.map((post: any) => (
                    <Card11 key={post.id} post={post} />
                  ))}
                </div>

                {/* PAGINATION */}
                <div className="flex flex-col mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
                  <ButtonPrimary>Show me more</ButtonPrimary>
                </div>
              </main>
              :
              <>
                Nothing to show
              </>
            }

            {/* SUBSCRIBES */}
            <SectionSubscribe2 />
          </div>
        </>
        :
        <></>
      }
    </div>
  );
};

export default PageAuthor;
